import { render, staticRenderFns } from "./DbButtonAutoFit.vue?vue&type=template&id=b7c1b3e2&"
import script from "./DbButtonAutoFit.vue?vue&type=script&lang=ts&"
export * from "./DbButtonAutoFit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports